import React, { Fragment, useState } from "react";
import { Image } from "../../../../AbstractElements";

const CurrentUser = () => {
  const [userdetails, setUserdetails] = useState(
    JSON.parse(localStorage.getItem("userdetails"))
  );
  // const { currentUserr } = useContext(ChatAppContext);
  // const { layoutURL } = useContext(CustomizerContext);
  // var images = require.context("../../../../assets/images", true);
  // const dynamicImage = (image) => {
  //   return images(`./${image}`);
  // };

  return (
    <Fragment>
      {userdetails && (
        <div className="media login-user-section">
          <Image
            attrImage={{
              src: `${userdetails?.employee_profile}`,
              className: "rounded-circle user-image",
              alt: "",
            }}
          />
          <div className="about">
            {/* <Link to={`${process.env.PUBLIC_URL}/app/users/profile/${layoutURL}`}>
              <div className='name f-w-600'>{currentUserr.name}</div>
            </Link> */}
            <div className="name f-w-600">{userdetails?.username}</div>
            {/* <div className='status'>{currentUserr.status}</div> */}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default CurrentUser;
